import ApplicationController from './application_controller';

// Debounced search + immediate facility filter on the assign-patients modal.
// Re-fetches the modal body with the new filters and swaps it in place,
// preserving the modal open state.
export default class extends ApplicationController {
  static targets = ['search', 'facility', 'caseload'];
  static values = { baseUrl: String };

  connect() {
    this.timeout = null;
    this.initSelectize();
  }

  // Selectize is normally initialized once at page load by application.js /
  // front_pages.js. Modal content is fetched AFTER page load (and re-fetched
  // on each filter change), so we manually init Selectize on the .select.filterable-no-sort
  // dropdowns inside the modal — both on connect and after every swap.
  initSelectize() {
    if (typeof window.jQuery === 'undefined') return;
    window.jQuery(this.element).find('.select.filterable-no-sort').each(function () {
      if (!this.selectize) {
        window.jQuery(this).selectize({ create: false });
      }
    });
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.filter(), 250);
  }

  async filter() {
    const params = new URLSearchParams();
    if (this.hasSearchTarget && this.searchTarget.value.trim()) {
      params.set('q', this.searchTarget.value.trim());
    }
    if (this.hasFacilityTarget && this.facilityTarget.value) {
      params.set('facility_id', this.facilityTarget.value);
    }
    if (this.hasCaseloadTarget && this.caseloadTarget.value) {
      params.set('caseload_id', this.caseloadTarget.value);
    }

    const url = `${this.baseUrlValue}?${params.toString()}`;
    await this.fetchAndSwap(url, { focusSearch: true });
  }

  async fetchAndSwap(url, { focusSearch }) {
    try {
      const response = await fetch(url, {
        headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
      const html = await response.text();
      const content = document.querySelector('[data-assign-patients-modal-target="content"]');
      if (!content) return;

      content.innerHTML = html;
      // Re-init Selectize on the freshly-swapped dropdowns. innerHTML replaces
      // their DOM nodes so the old Selectize wrappers are gone with them.
      this.initSelectize();
      if (focusSearch) {
        const newSearch = content.querySelector('[data-assign-patients-filter-target="search"]');
        if (newSearch) {
          newSearch.focus();
          const len = newSearch.value.length;
          newSearch.setSelectionRange(len, len);
        }
      }
    } catch (err) {
      console.error('assign-patients fetch failed:', err);
    }
  }
}
